import { useState } from "react";
import { useTranslation } from "react-i18next";

function NotificationFilter() {
  const { t } = useTranslation();
  const [click, setClick] = useState<number>();
  return (
    <div>
      <div className="flex items-center px-6 gap-2 py-3 mb-4 mt-3 overflow-x-auto overflow-y-hidden scrollbar-hidden">
        <button
          className="btn btn-sm btn-primary flex items-center gap-1 shrink-0"
          onClick={() => {
            setClick(1);
          }}
        >
          {`${t("ALL")}`}
        </button>
        {/* 
        <button
          className="btn btn-sm btn-outline-primary flex items-center gap-1 shrink-0"
          // onClick={}
        >
          {`${t("NOTIFICATIONS")}`}
        </button>
        <button
          className="btn btn-sm btn-outline-primary flex items-center gap-1 shrink-0"
          // onClick={}
        >
          {`${t("REQUESTS")}`}
        </button> */}
      </div>
    </div>
  );
}

export default NotificationFilter;
